import { Typography } from '@mui/material';

import styled from '../../styled';
import { colorsPalette } from '../../theme';

export const H1 = styled(Typography)`
  color: ${colorsPalette.white};
  & {
    font-size: 32px;
    line-height: 1.2;
    font-weight: bold;

    ${({ theme }) => theme.breakpoints.up('md')} {
      font-size: 40px;
    }
  }
`;

export const H2 = styled(Typography)`
  color: ${colorsPalette.white};
  & {
    font-size: 24px;
    line-height: 1.2;
    font-weight: bold;
    ${({ theme }) => theme.breakpoints.up('md')} {
      font-size: 28px;
    }
  }
`;

export const H3 = styled(Typography)`
  color: ${colorsPalette.white};
  & {
    font-size: 20px;
    line-height: 1.2;
    font-weight: bold;
  }
`;

export const H4 = styled(Typography)`
  color: ${colorsPalette.white};
  & {
    font-size: 18px;
    line-height: 1.2;
    font-weight: bold;
  }
`;

export const BodyIntroText = styled(Typography)`
  font-size: 18px;
  line-height: 1.5;
  color: ${colorsPalette.white};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 20px;
  }
`;

export const BodyText = styled(Typography)`
  font-size: 16px;
  line-height: 1.5;
  color: ${colorsPalette.gray};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 18px;
    line-height: 1.44;
  }
`;

export const ButtonText = styled(Typography)`
  font-size: 16px;
  line-height: 20px;
  color: ${colorsPalette.white};
`;

export const MetaText = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${colorsPalette.gray};
`;
